let options = {
    navigation: {
        prevEl: '.js-slider-teaser-prev',
        nextEl: '.js-slider-teaser-next',
        disabledClass: 'hidden',
    },
    spaceBetween: 20,
    slidesPerView: 1.05,
    watchSlidesVisibility: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
};

const sliderTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-slider-teaser');

        if (!elements.length) return;

        elements.forEach((element) => {
            const Slider = slider.default;
            if (typeof element.dataset.thumbs !== 'undefined') {
                const thumbOptions = {
                    spaceBetween: 8,
                    slidesPerView: 3.15,
                    watchSlidesVisibility: true,
                };

                this.secondeaser = new Slider(document.querySelector(element.dataset.thumbs), thumbOptions);
                options = {...options, thumbs: {swiper: this.secondeaser.swiper}};
            }

            this.sliderTeaser = new Slider(element, options);
        });
    },
};

export default sliderTeaser;
